import _ from 'lodash';

import domains from '../containers/Domains';
import {getLocalStorageDataOrFetch} from './fbCallManager';


const endpoint = domains.fbEndpoint;

export const getAccounts = async (userId, token) => {
  const parameters = {
    access_token: token,
    user_Id: userId,
    fields: 'owned_ad_accounts.limit(100000){name,account_id}'
  };

  const query = _.template(`${endpoint}<%= user_Id%>?fields=<%= fields%>&access_token=<%= access_token%>`);
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));
  return jsonResult;
};

export const getAccount = async (accountId, token) => {
  const parameters = {
    access_token: token,
    account_Id: accountId,
    fields: 'id,name,adspixels',
  };

  const query = _.template(`${endpoint}act_<%= account_Id%>?fields=<%= fields%>&access_token=<%= access_token%>`);
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));
  return jsonResult;
};



// WEBPACK FOOTER //
// ./src/fbApi/Account.js